import { render, staticRenderFns } from "./NewsItemM.vue?vue&type=template&id=e2399144&scoped=true"
import script from "./NewsItemM.vue?vue&type=script&lang=ts"
export * from "./NewsItemM.vue?vue&type=script&lang=ts"
import style0 from "./NewsItemM.vue?vue&type=style&index=0&id=e2399144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2399144",
  null
  
)

export default component.exports